// src/components/Writings/SaveStatusPanel.tsx
import { Flex, Spinner, Text } from "@chakra-ui/react";

interface SaveStatusPanelProps {
  isSaving: boolean;
  isDirty: boolean;
  lastSavedTime: string | null;
}

export function SaveStatusPanel({
  isSaving,
  isDirty,
  lastSavedTime,
}: SaveStatusPanelProps) {
  return (
    <Flex alignItems="center" gap={2}>
      {isSaving && <Spinner size="xs" color="gray.500" />}
      <Text fontSize="sm" color="gray.500" marginBottom="8px">
        {isSaving
          ? "저장 중..."
          : isDirty
            ? "저장되지 않은 변경사항 있음"
            : lastSavedTime
              ? `마지막 저장: ${lastSavedTime}`
              : "아직 저장되지 않음"}
      </Text>
      {/* <Button
        size="sm"
        colorScheme="blue"
        loading={isSaveLoading}
      >
        Save
      </Button> */}
    </Flex>
  );
}
